export default [{
    id: 1,
    name: 'Marcus Lopez',
    src: "./static/images/characters/marcus-lopez.png",
    thumb: "./static/images/characters/thumb-marcus-lopez.png",
    description: 'LOCALE.MARCUS.DESCRIPTION',
    color: '#d82a52',
    tabIndex: 1,
    aria: {
        title: 'LOCALE.ACCESSIBILITY.MARCUS.TITLE',
        altImgData: 'LOCALE.ACCESSIBILITY.MARCUS.ALTERNATIVE_IMAGE_DATA',
        button: 'LOCALE.ACCESSIBILITY.MARCUS.BUTTON',
    }

}, {
    id: 3,
    name: 'Saya',
    src: "./static/images/characters/saya.png",
    thumb: "./static/images/characters/thumb-saya.png",
    description: 'LOCALE.SAYA.DESCRIPTION',
    color: '#f9db53',
    tabIndex: 2,
    aria: {
        title: 'LOCALE.ACCESSIBILITY.SAYA.TITLE',
        altImgData: 'LOCALE.ACCESSIBILITY.SAYA.ALTERNATIVE_IMAGE_DATA',
        button: 'LOCALE.ACCESSIBILITY.SAYA.BUTTON',
    }
}, {
    id: 5,
    name: 'Billy',
    src: "./static/images/characters/billy.png",
    thumb: "./static/images/characters/thumb-billy.png",
    description: 'LOCALE.BILLY.DESCRIPTION',
    color: '#049fbd',
    tabIndex: 3,
    aria: {
        title: 'LOCALE.ACCESSIBILITY.BILLY.TITLE',
        altImgData: 'LOCALE.ACCESSIBILITY.BILLY.ALTERNATIVE_IMAGE_DATA',
        button: 'LOCALE.ACCESSIBILITY.BILLY.BUTTON',
    }
}, {
    id: 4,
    name: 'Maria',
    src: "./static/images/characters/maria.png",
    thumb: "./static/images/characters/thumb-maria.png",
    description: 'LOCALE.MARIA.DESCRIPTION',
    color: '#e1248b',
    tabIndex: 4,
    aria: {
        title: 'LOCALE.ACCESSIBILITY.MARIA.TITLE',
        altImgData: 'LOCALE.ACCESSIBILITY.MARIA.ALTERNATIVE_IMAGE_DATA',
        button: 'LOCALE.ACCESSIBILITY.MARIA.BUTTON',
    }
}, {
    id: 2,
    name: 'Master Lin',
    src: "./static/images/characters/master-lin.png",
    thumb: "./static/images/characters/thumb-master-lin.png",
    description: 'LOCALE.MASTER.DESCRIPTION',
    color: '#73a45e',
    tabIndex: 5,
    aria: {
        title: 'LOCALE.ACCESSIBILITY.MASTER.TITLE',
        altImgData: 'LOCALE.ACCESSIBILITY.MASTER.ALTERNATIVE_IMAGE_DATA',
        button: 'LOCALE.ACCESSIBILITY.MASTER.BUTTON',
    }
//     "name": 'Willie',
//     "src": "./static/images/characters/willie.png",
//     "description": 
    // <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>, {
//     "name": 'Chico',
//     "src": "./static/images/characters/chico.png",
//     "description": 
    // <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
}];